var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.77 179.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.67,4.25C29.29-.44,17.58-.44,10.55,8.94,3.52,18.31,1.17,20.65,1.17,34.72s9.37,23.43,9.37,30.46,4.69,18.75,2.34,35.15c-2.34,16.4,11.72,74.99,18.75,77.33,7.03,2.34,9.37-2.34,9.37-11.72s2.34-42.18,4.69-49.21c2.34-7.03,9.37-16.4,14.06-2.34,4.69,14.06,7.03,51.56,7.03,53.9s2.34,11.72,9.37,0c7.03-11.72,21.09-35.15,18.75-56.24-2.34-21.09-4.69-35.15,0-44.53l4.69-9.37s9.37-23.43,4.69-35.15c-4.69-11.72-16.4-21.09-30.46-18.75-14.06,2.34-25.78,4.69-35.15,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.26,74.55s39.84,4.69,60.93,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.26,23s2.34-4.69,11.72-2.34c9.37,2.34,18.75,2.34,18.75,7.03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m52.73,13.62s-4.69,11.72,14.06,7.03c18.75-4.69,21.09,4.69,21.09,4.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth31);
export default __webpack_public_path__ + "static/media/tooth-31.a901d2e97013938f431bdf0429219a3c.svg";
export { ForwardRef as ReactComponent };